import React, { Component } from 'react';
import withRouter from "../../../components/messenger/withRouter";
import { connect } from "react-redux"
import { changeLayoutMode } from '../../../store/messenger/actions';


class Index extends Component {
    constructor(props) {
        super(props);
        this.state={};
        this.capitalizeFirstLetter.bind(this);
    }
    
    //function for capital first letter of current page pathname
    capitalizeFirstLetter = string => {
        return string.charAt(1).toUpperCase() + string.slice(2);
    };

    componentDidMount(){
        var getLayoutMode = localStorage.getItem("layoutMode");
        this.props.changeLayoutMode(getLayoutMode);
        if (getLayoutMode) {
            this.props.changeLayoutMode(getLayoutMode);
        } else {
            this.props.changeLayoutMode(this.props.layoutMode);
        }

        let currentage = this.capitalizeFirstLetter(this.props.router.location.pathname);

        //set document title according to page path name
        document.title = currentage + " | Chatvia - Responsive Bootstrap 5 Admin Dashboard";
    }
    
    render() {
        return (
            <React.Fragment>
                <div className="layout-wrapper d-lg-flex">
                        {/* render page content */}
                        {this.props.children}
                </div>
            </React.Fragment>
        );
    }
}


const mapStateToProps = (state) => {
    //console.log("layout is",state)
    const { layoutMode } = state.Layout;
    return { layoutMode };
  };

export default withRouter(connect(mapStateToProps, { changeLayoutMode })(Index))